import { call, put, takeLatest } from "redux-saga/effects";
import { callAPI, handleError, handleSuccess } from "../api/api";
import axios from "axios";
import {
  addFuelDetails,
  addVehicleAction,
  addVehicleServiceHistory,
  addVehicleServicePaid,
  addVehicleTypeAction,
  addWorkerVehiclesAction,
  deleteVehicleAction,
  deleteVehicleService,
  deleteVehicleServiceSuccess,
  deleteVehicleSuccess,
  deleteVehicleType,
  deleteVehicleTypeSuccess,
  getAllVehicles,
  getAllVehiclesWithPagination,
  getAllWorkerVehicles,
  getFuelDetails,
  getSingleVehicleTypeDetails,
  getVehicleById,
  getVehicleServiceHistory,
  getVehicleTypes,
  setAddFuelDetails,
  setAddVehicleResponse,
  setAddVehicleServiceHistory,
  setAddVehicleTypeResponse,
  setAllVehicles,
  setAllWorkerVehicles,
  setFuelDetails,
  setSingleVehicleTypeDetails,
  setUpdateVehicleResponse,
  setUpdateVehicleTypeResponse,
  setVehicleById,
  setVehicleServiceHistory,
  setVehicleServicePaid,
  setVehicleTypes,
  setWorkerVehiclesAction,
  updateVehiclesAction,
  updateVehicleTypes,
} from "../reducers/vehicleSlice";
import { setLoaderAction, setNotificationAction } from "../reducers/mmymSlice";

/**
 * This function for call the user profile
 *
 * @param {*} payload
 */

function* getAllVehicleSaga(): any {
  yield put(setLoaderAction(true));
  try {
    const res = yield call<any>(callAPI, {}, "get", `client/vehicles`);
    if (res?.data) {
      yield put(setAllVehicles(res?.data));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response, [401]);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* getAllVehiclesWithPaginationSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  const { page, limit, orderBy, orderIn, search } = payload?.payload;
  try {
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `client/vehicles?pagination=true&page=${page}&limit=${limit}&orderBy=${orderBy}&orderIn=${orderIn}&search=${search}`
    );
    if (res?.data) {
      yield put(setAllVehicles(res?.data));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response, [401]);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* getVehicleTypesSaga(): any {
  yield put(setLoaderAction(true));
  try {
    const res = yield call<any>(callAPI, {}, "get", `client/vehicle-types`);
    if (res?.data) {
      yield put(setVehicleTypes(res?.data));
    }
  } catch (error) {
  }
  yield put(setLoaderAction(false));
}

function* addVehicleTypeSaga(payload: any[]): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "post",
      "client/vehicle-types"
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setAddVehicleTypeResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
  }
  yield put(setLoaderAction(false));
}

function* updateVehicleTypesSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "put",
      `client/vehicle-types/${payload?.payload.id}`
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setUpdateVehicleTypeResponse(true));
    }
  } catch (error) {
  }
  yield put(setLoaderAction(false));
}

function* addVehicleActionSaga(payload: any[]): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "post",
      "client/vehicles"
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setAddVehicleResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setAddVehicleResponse(false));
  }
  yield put(setLoaderAction(false));
}

function* getSingleVehicleTypeDetailsSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  try {
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `client/vehicle-types/${payload?.payload}`
    );
    if (res?.data) {
      yield put(setSingleVehicleTypeDetails(res?.data));
    }
  } catch (error) {
  }
  yield put(setLoaderAction(false));
}

function* getVehicleByIdSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  try {
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `client/vehicles/${payload?.payload}`
    );
    if (res?.data) {
      yield put(setVehicleById(res?.data));
    }
  } catch (error) {
  }
  yield put(setLoaderAction(false));
}

function* addVehicleServiceHistorySaga(payload: any[]): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "post",
      "client/vehicle-services"
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setAddVehicleServiceHistory(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setAddVehicleServiceHistory(false));
  }
  yield put(setLoaderAction(false));
}

function* getVehicleServiceHistorySaga(payload: { payload: any }): any {
  const { selectedId, page } = payload?.payload;
  yield put(setLoaderAction(true));
  try {
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `client/vehicle-services?vehicle_id=${selectedId}&page=${page}`
    );
    if (res?.data) {
      yield put(setVehicleServiceHistory(res?.data));
    }
  } catch (error) {
  }
  yield put(setLoaderAction(false));
}

function* updateVehicleActionSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    // const {id} = payload;
    const { id, ...newPayload } = payload?.payload;
    const apiResponse = yield call<any>(
      callAPI,
      { payload: newPayload },
      "post",
      `client/vehicles/${id}`
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setUpdateVehicleResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setUpdateVehicleResponse(false));
  }
  yield put(setLoaderAction(false));
}

function* getWorkerVehicleSaga(): any {
  yield put(setLoaderAction(true));
  try {
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `client/workers-and-vehicles`
    );
    if (res?.data) {
      yield put(setAllWorkerVehicles(res?.data));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response, [401]);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* addWorkerVehiclesSaga(payload: any[]): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "post",
      "client/workers-and-vehicles"
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setWorkerVehiclesAction(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setWorkerVehiclesAction(false));
  }
  yield put(setLoaderAction(false));
}

function* getFuelDetailsSaga(): any {
  yield put(setLoaderAction(true));
  try {
    const res = yield call<any>(callAPI, {}, "get", `client/fuel-rate`);
    if (res?.data) {
      yield put(setFuelDetails(res?.data));
    }
  } catch (error) {
  }
  yield put(setLoaderAction(false));
}

function* addFuelDetailsSaga(payload: any[]): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "post",
      "client/fuel-rate"
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setNotificationAction({ message: [], severity: "error" }));
      yield put(setAddFuelDetails(true));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }   
  yield put(setLoaderAction(false));
}

function* addVehicleServicePaidSaga(payload: any[]): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "post",
      "client/vehicle-payments"
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setVehicleServicePaid(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setVehicleServicePaid(false));
  }
  yield put(setLoaderAction(false));
}

function* deleteVehicleServiceSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "delete",
      `client/vehicle-services/${payload?.payload}`
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(deleteVehicleServiceSuccess(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(deleteVehicleServiceSuccess(false));
  }
  yield put(setLoaderAction(false));
}

function* deleteVehicleTypeSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "delete",
      `client/vehicle-types/${payload?.payload}`
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(deleteVehicleTypeSuccess(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* deleteVehicleActionSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "delete",
      `client/vehicles/${payload?.payload}`
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(deleteVehicleSuccess(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}



export function* watchVehicle() {
  yield takeLatest<any>(getAllVehicles, getAllVehicleSaga);
  yield takeLatest<any>(getAllVehiclesWithPagination, getAllVehiclesWithPaginationSaga);
  yield takeLatest<any>(addVehicleTypeAction, addVehicleTypeSaga);
  yield takeLatest<any>(getVehicleTypes, getVehicleTypesSaga);
  yield takeLatest<any>(
    getSingleVehicleTypeDetails,
    getSingleVehicleTypeDetailsSaga
  );
  yield takeLatest<any>(addVehicleAction, addVehicleActionSaga);
  yield takeLatest<any>(updateVehicleTypes, updateVehicleTypesSaga);
  yield takeLatest<any>(getVehicleById, getVehicleByIdSaga);
  yield takeLatest<any>(updateVehiclesAction, updateVehicleActionSaga);
  yield takeLatest<any>(getAllWorkerVehicles, getWorkerVehicleSaga);
  yield takeLatest<any>(addWorkerVehiclesAction, addWorkerVehiclesSaga);
  yield takeLatest<any>(getVehicleServiceHistory, getVehicleServiceHistorySaga);
  yield takeLatest<any>(addVehicleServiceHistory, addVehicleServiceHistorySaga);
  yield takeLatest<any>(getFuelDetails, getFuelDetailsSaga);
  yield takeLatest<any>(addFuelDetails, addFuelDetailsSaga);
  yield takeLatest<any>(addVehicleServicePaid, addVehicleServicePaidSaga);
  yield takeLatest<any>(deleteVehicleService, deleteVehicleServiceSaga);
  yield takeLatest<any>(deleteVehicleType, deleteVehicleTypeSaga);
  yield takeLatest<any>(deleteVehicleAction, deleteVehicleActionSaga);
  
}
